import React, { useEffect, useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import PermissionService from '../services/permission-service';
import { authenticate } from '../services/auth-service';
import userService from '../services/user-service';
import AppContext from '../app-context';

const withAccessControl = (WrapComponent) => (props) => {
  const history = useHistory();
  const { site } = useContext(AppContext);
  const [hasPermission, setHasPermission] = useState(false);
  const { permissionPrefix } = site || {};

  useEffect(() => {
    if (process.env.REACT_APP_SKIP_AUTH) {
      return;
    }
    if (!userService.isLoggedIn()) {
      authenticate().then((url) => {
        if (url) {
          history.push(url);
        }

        setHasPermission(true);
      });
    } else if (!PermissionService.has(history.location.pathname, null, permissionPrefix)) {
      history.push('/403');
    } else {
      setHasPermission(true);
    }
  }, [history, permissionPrefix]);

  if (process.env.REACT_APP_SKIP_AUTH) {
    return <WrapComponent {...props} />;
  }

  return hasPermission ? <WrapComponent {...props} /> : null;
};

export default withAccessControl;
